// @ts-expect-error: Error of not matching formats
import { xmlToJson } from './XmlToJson';

interface faultObject {
	faultcode: string;
	faultstring: string;
	detail?: {
		afLegacyDetail?: string;
		afLlegacyFaultactor?: string;
		afException?: string;
	};
}

const aml = {
	faultToJSON(xml: HTMLElement): faultObject | null {
		const result = xml?.firstChild?.firstChild?.firstChild;
		if (!result) {
			return null;
		}
		const isFault = result.nodeName.toLowerCase() === 'soap-env:fault';

		if (isFault) {
			const obj = xmlToJson(result);
			delete obj['@attrs'];
			return obj;
		}

		return null;
	}
};

export default aml;
